import { Themes, Theme } from '../types';
import { darkThemeColors } from '../theme-colors/dark';
import { lightThemeColors } from '../theme-colors/light';

export const colorPrefix = '--colors-';

export const themeToCssVariables = (themeColors: Record<string, string>, overwrittenColors?: Record<string, string>): string => {
  const mergedColors = { ...themeColors };

  if (overwrittenColors) {
    Object.entries(overwrittenColors).forEach(([key, value]) => {
      if (value !== '' && value !== undefined) mergedColors[key] = value;
    });
  }

  const cssVariables = Object.entries(mergedColors)
    .map(([key, value]) => `${colorPrefix}${key}: ${value};`)
    .join(' ');

  return `* { ${cssVariables} }`;
};

export const getCssVariableBasedOnTheme = (theme: Themes) => (theme === Theme.dark ? darkThemeColors : lightThemeColors);
